// Códigos del wizard (teléfono y firma): espera para reenviar, teléfono enmascarado y rechazos. Puro.
import { ApiError } from '@/api/errors';

/** Vigencia del código en messages-business (`OTP_EXPIRATION_TIME`, 120 s en dev). */
export const OTP_LIFETIME_SECONDS = 120;

/** Espera entre envíos: lo que dura el código, así no se pide otro mientras el anterior vale. */
export const OTP_RESEND_SECONDS = OTP_LIFETIME_SECONDS;

/** «Dura 2 minutos.» */
export const OTP_LIFETIME_TEXT = `Dura ${String(OTP_LIFETIME_SECONDS / 60)} minutos.`;

/** «Te mandamos el código al 33•• ••• 1185. Dura 2 minutos.» */
export function otpSentMessage(destination: string): string {
    return `Te mandamos el código al ${destination}. ${OTP_LIFETIME_TEXT}`;
}

/** `45` → `0:45`, `75` → `1:15`. */
export function formatCountdown(seconds: number): string {
    const s = Math.max(0, Math.ceil(seconds));
    return `${String(Math.floor(s / 60))}:${String(s % 60).padStart(2, '0')}`;
}

/** `3312341185` → `33•• ••• 1185`; `null` si no hay 10 dígitos. */
export function maskedPhone(phone: string | undefined): string | null {
    const digits = (phone ?? '').replace(/\D/g, '').slice(-10);
    if (digits.length !== 10) return null;
    return `${digits.slice(0, 2)}•• ••• ${digits.slice(-4)}`;
}

/** Segundos que pide esperar un rechazo por reenvío (cooldown o 429); `undefined` si no es eso. */
export function resendWaitSeconds(error: unknown): number | undefined {
    if (!(error instanceof ApiError)) return undefined;
    const isWait =
        error.httpStatus === 429 ||
        ['OTP_RESEND_COOLDOWN', 'RATE_LIMITED', 'TOO_MANY_REQUESTS'].includes(error.code);
    if (!isWait) return undefined;
    const data = error.data as { secondsLeft?: unknown; retryAfterSeconds?: unknown } | undefined;
    const left = data?.secondsLeft ?? data?.retryAfterSeconds;
    return typeof left === 'number' && left > 0 ? left : OTP_RESEND_SECONDS;
}
